import { contactsContext, useContactsContextValue } from './context';

export interface ContactsProviderProps {
  children: ReactNode;
}

export function ContactsProvider({ children }: ContactsProviderProps) {
  const value = useContactsContextValue();
  return <contactsContext.Provider value={value}>{children}</contactsContext.Provider>;
}
